import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FlagService } from 'src/app/services/flag/flag.service';

@Component({
  selector: 'app-flag-selector',
  templateUrl: './flag-selector.component.html',
  styleUrls: ['./flag-selector.component.scss']
})
export class FlagSelectorComponent implements OnInit {
  @Input() selectedLanguage: string = '';
  @Input() disabled: boolean = false;
  @Input() showFlag: boolean = true;
  @Input() flagSize: number = 20;
  @Output() languageChange = new EventEmitter<string>();

  flagUrl: string = '';
  fallbackFlag: string = '';
  imageError: boolean = false;

  constructor(private flagService: FlagService) {}

  ngOnInit() {
    this.updateFlag();
  }

  ngOnChanges() {
    this.updateFlag();
  }

  private updateFlag() {
    if (this.selectedLanguage && this.showFlag) {
      this.flagUrl = this.flagService.getFlagUrlWithSize(this.selectedLanguage, this.flagSize);
      this.fallbackFlag = this.flagService.getFallbackFlag(this.selectedLanguage);
      this.imageError = false;
    }
  }

  onImageError() {
    this.imageError = true;
  }

  get displayContent(): string {
    if (this.imageError || !this.showFlag) {
      return this.fallbackFlag;
    }
    return '';
  }
}
